type LifeStoryTextSource = {
  displayText?: string | null;
  editedTranscriptText?: string | null;
  transcriptText?: string | null;
  responseText?: string | null;
  text?: string | null;
};

export const getLifeStoryResponseText = (response?: LifeStoryTextSource | null) =>
  response?.responseText ||
  response?.text ||
  response?.displayText ||
  response?.editedTranscriptText ||
  response?.transcriptText ||
  '';